import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PublicEditProfileStatusTypesType, QuoteStatus, StatusType } from 'globals/store/share.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiResource } from 'globals/store/resources.data';
import { PublicQuoteInfo, BudgetQuoteSection, Budget, SectionSettings } from '../../store/reselectors/budget.data';
import { JoiEvent } from 'globals/store/events.data';
import { BudgetSectionGridData, PaymentGridData } from '../../helpers/grid-helpers';
import { quoteSectionReselector } from '../../store/reselectors/quotes.reselector';
import { ManageQuoteData } from '../../store/reselectors/quotes.data';
import { colorsByStatus } from '../../store/performers.era';
import { generateEmailLink, sleepForMS, urlIsValid } from 'src/app/helpers/helpers';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { compactDate, jsonCopyObject, str2Date } from 'globals/helpers/helpers';
import { updateBudgetSectionInPlace } from 'globals/helpers/budget.helper';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { CommonModule } from '@angular/common';
import { TrafficLightDropdownComponent } from 'src/app/components/misc/traffic-light-dropdown.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { DatePickerComponent } from 'src/app/components/misc/date-picker.component';
import { TitleToggleComponent } from 'src/app/components/wrappers/title-toggle-wrapper.component';
import { ShareCodeComponent } from '../share/share-code.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { EditLinkComponent } from 'src/app/components/misc/edit-link.component';
import { BudgetSectionComponent } from '../budget/budget-section.component';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'manage-quote',
    templateUrl: './manage-quote.html',
    styleUrls: ['./manage-quote.scss'],
    standalone: true,
    imports: [BigDialogWrapperComponent, IconComponent, CommonModule, TrafficLightDropdownComponent, TipTextComponent, DatePickerComponent, TitleToggleComponent, ShareCodeComponent, JoiInputComponent, InputEditorComponent, EditLinkComponent, BudgetSectionComponent],
})
export class ManageQuoteDialogComponent extends Wrapper<ManageQuoteDialogComponent> implements AfterViewInit {
  resource: JoiResource
  quote: BudgetQuoteSection
  quoteInfo: PublicQuoteInfo
  budget: Budget
  event: JoiEvent
  deleteText = 'Are you sure you want to delete this quote from this resource / event?'
  scheduleGridData: PaymentGridData[]
  gridData: BudgetSectionGridData[]
  statusOptions: QuoteStatus[] = ['Accepted', 'Pending', 'Declined']
  colorsByStatus = colorsByStatus
  linkInvalid = false
  @ViewChild('sectionTitle') sectionTitle: JoiInputComponent

  constructor(public dialogRef: MatDialogRef<ManageQuoteDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageQuoteData) {
    super()
    console.log({ data })
    this.subProp(this.store.select('resources', 'entities', this.data.resourceId), 'resource')
    this.subProp(this.store.select('shareables', 'quote', this.data.quoteId), 'quoteInfo')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.selectCallback<{gridData: BudgetSectionGridData[],scheduleGridData: PaymentGridData[], quote: BudgetQuoteSection;}, any>(quoteSectionReselector, this.data, ({ gridData, scheduleGridData, quote }) => {
      this.gridData = gridData
      this.scheduleGridData = scheduleGridData
      this.quote = quote
    })
  }

  ngAfterViewInit(): void {
    if (this.data.focusSectionName || !this.resource.name) setTimeout(() => this.sectionTitle.manualFocus(), 300)
    this.checkLink()
  }

  emailGenerator(publishCode: string) {
    const contact = this.resource.contacts.find(c => c.id === this.resource.primaryContactId)
    const firstDate = this.event.first_date
    const dateText = firstDate ? `, ${compactDate(str2Date(firstDate))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information required for ${title}${dateText}`
    const greeting = contact?.firstName ? `Hi ${contact.firstName}` : 'Hi there'
    const body = `${greeting},\n\nWe would like you to provide a quote for our upcoming event.\n\nPlease click on the link below and complete the webform to submit your quote:\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body, contact?.email || '')
  }


  exit() {
    this.dialogRef.close()
  }

  async save() {
    console.log("Nothing to do...")
    this.exit()
  }

  saveDeadline(date) {
    console.log(this.quote.submissionDeadline, date)
    window['deadline'] = this.quote.submissionDeadline
    window['date'] = date
    this.quote.submissionDeadline = date.getTime()
    this.updateQuote()
  }

  changeQuoteStatus(status: string) {
    this.quoteInfo.quoteStatus = status as QuoteStatus
    this.updateInfo()
  }

  async changeQuoteInfoQuoteName() {
    await sleepForMS(50)
    const name = this.quote.name
    console.log({ name })
    this.quoteInfo.sectionName = name
    this.updateInfo()
  }

  changeInfoStatus(status: StatusType) {
    this.quoteInfo.status = status as PublicEditProfileStatusTypesType
    this.updateInfo()    
  }

  submitToggle(toggled: boolean) {
    this.quoteInfo.status = toggled ? 'Active' : 'Off'
    this.shareService.upsertPublicQuoteInfo(this.quoteInfo)
  }


  async delete() {
    delete this.budget.quotes[this.quote.id]    
    await this.budgetService.updateBudget(this.event.eventId, this.budget)

    const allQuoteIds = new Set(Object.keys(this.budget.quotes))
    this.resource.quoteIds = this.resource.quoteIds.filter(id => id !== this.quote.id && allQuoteIds.has(id))
    await this.resourceService.updateResource(this.resource)

    await this.shareService.deleteQuoteInfo(this.quote.id)
    this.exit()
  }

  checkLink() {
    this.linkInvalid = !urlIsValid(this.quote.quoteLink)
  }

  updateQuote(andInfo: boolean = false) {
    updateBudgetSectionInPlace(this.quote, this.budget.currency)
    this.checkLink()
    this.budget.quotes[this.quote.id] = { ... this.quote }
    console.log({ quote: this.quote })
    this.budgetService.updateBudget(this.event.eventId, this.budget)
    if (andInfo) this.updateInfo()
  }

  saveSectionSettingDefaults(settings: Partial<SectionSettings>) {
    this.accountService.checkAndUpdateBudgetSectionSettingsDefaults(settings)
  }

  updateInfo() {
    
    this.quoteInfo = {
      ...this.quoteInfo,
      sectionName: this.quote.name || '',
      referenceNo: this.quote.quoteRef || '',
    }
    console.log({ quote: jsonCopyObject(this.quote), quoteInfo: this.quoteInfo })
    this.shareService.upsertPublicQuoteInfo(this.quoteInfo)
  }

}

